var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 52,
    viewBox: "0 0 50 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6448 8.65191C23.5101 9.09779 23.4375 9.5715 23.4375 10.0625C23.4375 10.9427 24.1371 11.6562 25 11.6562H34.375C35.2379 11.6562 35.9375 10.9427 35.9375 10.0625C35.9375 9.5715 35.8649 9.09779 35.7302 8.65191M23.6448 8.65191C24.2349 6.69983 26.0175 5.28125 28.125 5.28125H31.25C33.3575 5.28125 35.1401 6.69983 35.7302 8.65191M23.6448 8.65191C22.8622 8.69949 22.082 8.75625 21.3043 8.82208C18.9479 9.02158 17.1875 11.0681 17.1875 13.48V18.0312M35.7302 8.65191C36.5128 8.69949 37.293 8.75625 38.0707 8.82208C40.4271 9.02158 42.1875 11.0681 42.1875 13.48V35.5625C42.1875 38.2031 40.0888 40.3438 37.5 40.3438H32.8125M17.1875 18.0312H10.1562C8.86183 18.0312 7.8125 19.1016 7.8125 20.4219V44.3281C7.8125 45.6484 8.86183 46.7188 10.1562 46.7188H30.4688C31.7632 46.7188 32.8125 45.6484 32.8125 44.3281V40.3438M17.1875 18.0312H30.4688C31.7632 18.0312 32.8125 19.1016 32.8125 20.4219V40.3438M15.625 33.9688L18.75 37.1562L25 29.1875",
    stroke: "#90CC61",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.329d7e8371a7ac2fcbabea1a9b512770.svg";
export { ForwardRef as ReactComponent };